import { useStore } from 'react-admin';

const useGetUserId = () => {
  const [userId, setUserId] = useStore('userId', 0);
  return userId;
};
export default useGetUserId;
